import React from 'react';
import useIsMobile from '@hooks/useIsMobile';

export default function NoFavorites() {
  const isMobile = useIsMobile();
  return (
    <div className={`mt-5 mb-5 ${isMobile ? 'mr-5 ml-5' : 'w-full'}`}>
      <div className="not-italic font-semibold text-xl leading-7 flex items-center text-gray-900 mt-2 mb-2">
        No favorites...yet!
      </div>
      <div className="not-italic font-normal text-base leading-7 flex items-end text-gray-500 mt-2 mb-2">
        As you search, tap the heart icon to save hotels you like, and find them all here.
      </div>
    </div>
  );
}
